/// <amd-module name="Artifacts/Cargo/commands/Promote" />

import { CargoActions } from "Artifacts/Cargo/redux";
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPromoteCommand = getPromoteCommandCreator(CargoActions.promote);
